var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
export default class SpinnerStore {
    constructor() {
        Object.defineProperty(this, "spinnerCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        makeObservable(this);
    }
    isVisible(name) {
        return this.spinnerCache.get(name) ? !!this.spinnerCache.get(name) : false;
    }
    show(spinnerName) {
        const existingSpinner = this.spinnerCache.get(spinnerName);
        if (existingSpinner) {
            return;
        }
        this.spinnerCache.set(spinnerName, 'spinner');
    }
    hide(spinnerName) {
        const spinner = this.spinnerCache.get(spinnerName);
        if (!spinner) {
            return;
        }
        this.spinnerCache.delete(spinnerName);
    }
}
__decorate([
    observable
], SpinnerStore.prototype, "spinnerCache", void 0);
__decorate([
    action.bound
], SpinnerStore.prototype, "show", null);
__decorate([
    action.bound
], SpinnerStore.prototype, "hide", null);
